export default __webpack_public_path__ + "static/media/Utric's Lawful Mace.1bdd6e99.jpg";